import React from 'react';
import FormFieldStyles from './FormField.styles';
const FormField = ({ size = 'default', children }) => {
    return React.createElement(FormFieldStyles.Element, { size: size }, children);
};
export default FormField;
